// Pairing code input component with visual digit display

import React, { useRef, useEffect } from 'react';
import styles from './PairingCodeInput.module.css';

const PairingCodeInput = ({ value, onChange, onSubmit, disabled }) => {
  const inputRef = useRef(null);

  useEffect(() => {
    // Auto-focus input on mount
    if (inputRef.current && !disabled) {
      inputRef.current.focus();
    }
  }, [disabled]);

  const handleChange = (e) => {
    onChange(e.target.value);

    // Auto-submit when 6 digits entered
    if (e.target.value.length === 6 && onSubmit) {
      setTimeout(() => onSubmit(), 100);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && value.length === 6) {
      onSubmit();
    }
  };

  return (
    <div className={styles.container}>
      <label className={styles.label}>Enter 6-Digit Pairing Code</label>

      <input
        ref={inputRef}
        type="text"
        inputMode="numeric"
        pattern="[0-9]*"
        maxLength={6}
        value={value}
        onChange={handleChange}
        onKeyPress={handleKeyPress}
        disabled={disabled}
        className={styles.input}
        placeholder="000000"
        autoComplete="off"
      />

      <div className={styles.digitDisplay}>
        {[0, 1, 2, 3, 4, 5].map((index) => (
          <div key={index} className={styles.digit}>
            {value[index] || ''}
          </div>
        ))}
      </div>
    </div>
  );
};

export default PairingCodeInput;
